// deps
import React, { ReactElement, memo, useContext, useMemo } from "react";

// interfaces
import { RouteProps } from "@payment-client/interfaces/Router";

// components
import CommonHeaderContent from "@payment-client/components/common-header-content/CommonHeaderContent";
import CommonUIWrapper from "@payment-client/components/common-ui-wrapper/CommonUIWrapper";
import { ShowPaymentContext } from "@payment-client/contexts/ShowPaymentContext";
import { PaymentOfferUIHandler } from "./payment-offers-ui-handler";

//constants
import { options } from "@payment-client/constants/Options";
import { TEXTS } from "./constants";

//contexts
import { PaymentPayContext } from "@payment-client/contexts/PaymentPayContext";

type PaymentOffersProps = RouteProps;

export const PaymentOffers = memo(function PaymentOffers(_: PaymentOffersProps): ReactElement | null {
    const { paymentResponse } = useContext(ShowPaymentContext);
    const { amountToPay } = useContext(PaymentPayContext);

    const content = (
        <PaymentOfferUIHandler
            paymentGroups={paymentResponse?.paymentOffersGroup}
            options={options}
            paymentAmount={String(amountToPay)}
        />
    );

    const header = useMemo(() => {
        return <CommonHeaderContent title={TEXTS.PAYMENT_OFFERS_PAGE_TITLE} grayscale />;
    }, []);

    return <CommonUIWrapper header={header} content={content} />;
});
